import data from "../../data/index.json";
import {Laptop} from 'react-bootstrap-icons';

export default function MySkills() {
  return (
    <section className="skills--section" id="MySkills">
      <div className="portfolio--container">
        <p className="section--title">Services</p>
        <h2 className="skills--section--heading">Our Services</h2>
      </div>
      <div className="skills--section--container">
        
        
          <div className="skills--section--card">
            <div className="skills--section--img">
              <img className ="skill-icon" src="./img/fd.png" alt="icon" />
            </div>
            <div className="skills--section--card--content">
              <h3 className="skills--section--title">
                Furniture Moving
              </h3>
              <p className="skills--section--description">Fast, reliable furniture delivery service. Safe transport, careful handling, and affordable rates.
                Perfect for homes, offices, and retailers.</p>
            </div>
          </div>

          <div  className="skills--section--card">
            <div className="skills--section--img">
              <img className ="skill-icon" src="./img/hm.png" alt="icon" />
            </div>
            <div className="skills--section--card--content">
              <h3 className="skills--section--title">Storage Moves</h3>
              <p className="skills--section--description">Secure, affordable furniture storage and moving service. Ideal for home or office. Flexible scheduling, 
                careful handling, and reliable transport.</p>
             
            </div>
          </div>

          <div className="skills--section--card">
            <div className="skills--section--img">
              <img className ="skill-icon" src="./img/pd.png" alt="icon" />
            </div>
            <div className="skills--section--card--content">
              <h3 className="skills--section--title">Parcel Delivery</h3>
              <p className="skills--section--description">Fast, reliable furniture and parcel delivery service. Safe handling, timely transport, 
                and affordable rates for homes and businesses.</p>
            
            </div>
          </div> 


           <div className="skills--section--card">
            <div className="skills--section--img">
              <img className ="skill-icon" src="./img/cs.png" alt="icon" />
            </div>
            <div className="skills--section--card--content">
              <h3 className="skills--section--title">Carpet Supply</h3>
              <p className="skills--section--description">Quality furniture and carpet supply service offering stylish, durable products with expert advice,
                 fast delivery, and professional installation.</p>
             
            </div>
          </div> 


           <div className="skills--section--card">
            <div className="skills--section--img">
              <img className ="skill-icon" src="./img/cf.png" alt="icon" />
            </div>
            <div className="skills--section--card--content">
              <h3 className="skills--section--title">Carpet Fitting</h3>
              <p className="skills--section--description">Professional furniture and carpet fitting service offering precise installation, reliable workmanship,
                 and affordable rates. Fast, tidy, and trusted.</p>
             
            </div>
          </div> 

           <div className="skills--section--card">
            <div className="skills--section--img">
              <img className ="skill-icon" src="./img/cc.png" alt="icon" />
            </div>
            <div className="skills--section--card--content">
              <h3 className="skills--section--title">Carpet Cleaning</h3>
              <p className="skills--section--description">Professional furniture and carpet cleaning service offering deep cleaning, stain removal,
                 and fresh results for homes and offices.</p>
            
            </div>
          </div> 

      
        
      </div>
    </section>
  );
}
